import React from 'react';
import { Breadcrumb } from 'antd';
import { useLocation } from 'react-router-dom';
import { toAdminBreadcrumbItems } from './adminMenu';

export const AdminBreadcrumb: React.FC = () => {
  const location = useLocation();

  return (
    <Breadcrumb
      style={{ marginBottom: 12 }}
      items={toAdminBreadcrumbItems(location.pathname)}
    />
  );
};

export default AdminBreadcrumb;
